<template>
    <div class="page-account">
        <div class="page-account-container">
            <div class="page-account-container">
                <div class="page-account-top">
                    <div class="page-account-top-logo">
                        <img src="@/assets/image/logo.png" alt="logo">
                    </div>
<!--                    <div class="page-account-top-desc">安徽国朗 CRM后台管理系统</div>-->
                </div>
                <div class="ivu-login">
                    <Form ref="formInline" :model="formInline" :rules="ruleInline" @keydown.enter="enterLogin">
                        <FormItem prop="userName">
                            <Input type="text" size="large" v-model="formInline.userName" placeholder="用户名">
                                <template #prepend>
                                    <Icon type="ios-person-outline"></Icon>
                                </template>
                            </Input>
                        </FormItem>
                        <FormItem prop="passWord">
                            <Input type="password" size="large" v-model="formInline.passWord" placeholder="密码">
                                <template #prepend>
                                    <Icon type="ios-lock-outline"></Icon>
                                </template>
                            </Input>
                        </FormItem>
                        <FormItem>
                            <Button size="large" type="primary" long @click="handleSubmit()">登录</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <footer class="ivu-global-footer i-copyright">
            <div class="ivu-global-footer-copyright">Copyright © 2025 安徽国朗建设工程有限公司 All Rights Reserved</div>
        </footer>
    </div>
</template>

<script>
import { login } from '@/apis/public'
export default {
    name: 'Login',
    components: {},
    data() {
        return {
            formInline: {
                userName: '',
                passWord: ''
            },
            ruleInline: {
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                passWord: [
                    { required: true, message: '请输入密码.', trigger: 'blur' },
                    { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
                ]
            }
        }
    },
    created() {

    },
    methods: {
        /**
         功能：回车登录
         time: 2025-19-01 17:19:06
         **/
        enterLogin(e){
            let that = this;
            if (e.keyCode === 13) {
                // 执行搜索操作
                that.handleSubmit();
            }
        },
        /**
         功能：登录
         time: 2025-19-01 17:19:27
         **/
        handleSubmit() {
            let that = this;
            try {
                this.$refs['formInline'].validate((valid) => {
                    if (valid) {
                       login(that.formInline).then(e => {
                           that.$Message.success({ background: true,duration:3, content: e.msg });
                           let data = e.data;
                           that.$store.commit('SET_TOKEN' , data.token);
                           that.$store.commit('SET_USERINFO' , data.auth);
                           that.$store.commit('SET_OPEN_NAMES' , 1);
                           that.$store.commit('SET_ACTIVE_NAMES' , 1);
                           that.$store.commit('SET_AUTH' , '');
                           that.$store.commit('SET_ROUTERS' , []);
                           let redirect = that.$route.query.redirect ;
                           if(!redirect) redirect = '/index';
                           that.$router.push({ path: redirect })
                       })
                    }
                })
            } catch (error) {
                return false
            }

        }
    }
}
</script>

<style lang="less" scoped>
    .page-account {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        height: 100vh;
        overflow: auto;
        &:after, &:before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 50%;
            bottom: 0;
            z-index: -1;
            background-image: url("../../assets/image/bg-login-left.png");
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: 100%;
        }
        &:after {
            left: 50%;
            right: 0;
            background-image: url(../../assets/image/bg-login-right.png);
        }
        .page-account-container {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            padding: 32px 0;
            text-align: center;
            width: 384px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-flow: column;
            .page-account-top {
                padding: 32px 0;
                width: 100%;
                .page-account-top-logo {
                    img {
                        height: 75px;
                    }
                }
                .page-account-top-desc {
                    font-size: 14px;
                    color: #808695;
                }
            }
            .ivu-login {
                width: 100%;
            }
        }
    }
</style>
